import { render } from "./errorList.vue?vue&type=template&id=35a752d5"
import script from "./errorList.vue?vue&type=script&lang=js"
export * from "./errorList.vue?vue&type=script&lang=js"

import "./errorList.vue?vue&type=style&index=0&id=35a752d5&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__